const backButtonComponent = {
    schema: {
      page: {type: 'string', default: ''},
      shop: {type: 'string', default: ''}
    },
    init() {
      const couponBtn = document.getElementById('coupon-btn')
      const backBtn = document.getElementById('back-btn')
      const baseUrl = 'https://coloane-macau.com/'
      const hiddenTreasureUrl = 'ar/the-hidden-treasure/'
      const couponUrl = 'my-coupons/get?shop='
      let slug = ''
  
      const d = new Date();
      let month = (d.getMonth() + 1).toString().padStart(2, '0');
      let day = d.getDate().toString().padStart(2, '0');
      let year = d.getFullYear();
      let today = [year, month, day].join('-');
      const code = btoa(today)
  
      // console.log(new Date())
      // console.log('page', this.data.page)
      // console.log('date', today)
      // console.log('code', code)
  
      if (backBtn) {
        if (this.data.page === 'calling-makmak') {
          backBtn.href = `${baseUrl}ar/calling-makmak`
        }
        // 遊天主堂
        else if (this.data.page === 'explore-the-church') {
         backBtn.href = `${baseUrl}ar/explore-the-church`
        }
        // 賞土風舞
        else if (this.data.page === 'enjoy-folk-dance') {
         backBtn.href = `${baseUrl}ar/enjoy-folk-dance`
        }
         // 戰勝海怪
        else if (this.data.page === 'fight-for-victory') {
         backBtn.href = `${baseUrl}ar/fight-for-victory`
        }
         // 葡國公雞
        else if (this.data.page === 'colourful-roosters') {
         backBtn.href = `${baseUrl}ar/colourful-roosters`
        }
        // 葡飾魅影
        else if (this.data.page === 'portuguese-headdress') {
         backBtn.href = `${baseUrl}ar/portuguese-headdress`
        }
        // 趣覓路牌（美女圍）
        else if (this.data.page === 'funny-signage-girl') {
         backBtn.href = `${baseUrl}ar/funny-signage-girl`
        }
        // 趣覓路牌（肥胖圍）
        else if (this.data.page === 'funny-signage-fat') {
         backBtn.href = `${baseUrl}ar/funny-signage-fat`
        }
        // 鎮店之寶
        else if (this.data.page === 'the-hidden-treasure') {
          backBtn.href = baseUrl + hiddenTreasureUrl + this.data.shop
        }
       
  
        if(couponBtn) {
          if(!this.data.shop) {
            // couponBtn.href = baseUrl + couponUrl + slug
          } else {
             couponBtn.href = baseUrl + hiddenTreasureUrl + this.data.shop + '/coupon?code=' + code 
          }
         
        }
        
      }
    },
  }
  
  export {backButtonComponent}
  